module.exports = __webpack_public_path__ + "img/img26.0882c93a.svg";